const marketingData = [
  // Marketing Questions (101-130)
  {
    id: 101,
    category: "Marketing",
    level: "hard",
    question: "What is the main purpose of a brand positioning statement?",
    options: [
      "To describe the company's financial goals",
      "To define how a brand wants to be perceived in the market",
      "To create detailed product specifications",
      "To outline marketing campaign budgets",
    ],
    answer: "To define how a brand wants to be perceived in the market",
  },
  {
    id: 102,
    category: "Marketing",
    level: "hard",
    question: "Which metric best shows customer engagement on social media?",
    options: [
      "Click-through rate (CTR)",
      "Likes, comments, and shares (Engagement rate)",
      "Customer Lifetime Value (CLV)",
      "Cost Per Acquisition (CPA)",
    ],
    answer: "Likes, comments, and shares (Engagement rate)",
  },
  {
    id: 103,
    category: "Marketing",
    level: "hard",
    question: "What is a 'pillar page' in content marketing?",
    options: [
      "A short blog post",
      "A detailed page that explains a main topic and links related posts",
      "A landing page for ads",
      "An internal company document",
    ],
    answer:
      "A detailed page that explains a main topic and links related posts",
  },
  {
    id: 104,
    category: "Marketing",
    level: "hard",
    question: "What does the AIDA model represent in marketing?",
    options: [
      "Attention, Interest, Desire, Action",
      "Analysis, Implementation, Development, Assessment",
      "Acquire, Integrate, Deploy, Automate",
      "Awareness, Innovation, Design, Advertising",
    ],
    answer: "Attention, Interest, Desire, Action",
  },
  {
    id: 105,
    category: "Marketing",
    level: "hard",
    question: "What does 'churn rate' measure?",
    options: [
      "Rate of new customers",
      "Percentage of customers leaving over time",
      "Average revenue per user",
      "Marketing campaign cost",
    ],
    answer: "Percentage of customers leaving over time",
  },
  {
    id: 106,
    category: "Marketing",
    level: "hard",
    question: "Who is a 'micro-influencer'?",
    options: [
      "An influencer with a small but engaged audience",
      "An influencer with millions of followers",
      "A social media bot",
      "A company employee promoting products",
    ],
    answer: "An influencer with a small but engaged audience",
  },
  {
    id: 107,
    category: "Marketing",
    level: "hard",
    question: "What is the main benefit of marketing automation tools?",
    options: [
      "Designs ads automatically",
      "Automates repetitive tasks like emails and posts",
      "Guarantees viral content",
      "Instant revenue growth",
    ],
    answer: "Automates repetitive tasks like emails and posts",
  },
  {
    id: 108,
    category: "Marketing",
    level: "hard",
    question: "Which of these is a type of market segmentation?",
    options: [
      "Geographic, Demographic, Psychographic, Behavioral",
      "Creative, Strategic, Tactical, Operational",
      "Primary, Secondary, Tertiary, Quaternary",
      "Inbound, Outbound, Paid, Organic",
    ],
    answer: "Geographic, Demographic, Psychographic, Behavioral",
  },
  {
    id: 109,
    category: "Marketing",
    level: "hard",
    question: "What is 'USP' in marketing?",
    options: [
      "Unique Selling Proposition",
      "User Service Plan",
      "Universal Sales Product",
      "Unified Strategy Process",
    ],
    answer: "Unique Selling Proposition",
  },
  {
    id: 110,
    category: "Marketing",
    level: "hard",
    question: "What is 'brand equity'?",
    options: [
      "The company's stock value",
      "The perceived value and strength of a brand",
      "The total marketing budget",
      "The cost of product development",
    ],
    answer: "The perceived value and strength of a brand",
  },
  {
    id: 111,
    category: "Marketing",
    level: "hard",
    question: "Which tool is used to analyze competitor strategies?",
    options: ["SWOT Analysis", "Pestle Analysis", "RFM Analysis", "5 Whys"],
    answer: "SWOT Analysis",
  },
  {
    id: 112,
    category: "Marketing",
    level: "hard",
    question: "What is the purpose of a marketing funnel?",
    options: [
      "To measure customer journey from awareness to purchase",
      "To track production costs",
      "To plan employee training",
      "To manage financial forecasts",
    ],
    answer: "To measure customer journey from awareness to purchase",
  },
  {
    id: 113,
    category: "Marketing",
    level: "hard",
    question: "Which is the primary goal of content marketing?",
    options: [
      "Sell products directly",
      "Educate, inform, or engage customers",
      "Manage finances",
      "Hire employees",
    ],
    answer: "Educate, inform, or engage customers",
  },
  {
    id: 114,
    category: "Marketing",
    level: "hard",
    question: "What is 'SEO' used for?",
    options: [
      "Paid advertising campaigns",
      "Optimizing a website to appear higher in search results",
      "Creating social media posts",
      "Managing email lists",
    ],
    answer: "Optimizing a website to appear higher in search results",
  },
  {
    id: 115,
    category: "Marketing",
    level: "hard",
    question:
      "Which type of marketing focuses on creating content that attracts customers?",
    options: [
      "Outbound Marketing",
      "Inbound Marketing",
      "Direct Marketing",
      "Trade Marketing",
    ],
    answer: "Inbound Marketing",
  },
  {
    id: 116,
    category: "Marketing",
    level: "hard",
    question: "What is 'customer lifetime value' (CLV)?",
    options: [
      "Revenue from a customer in one purchase",
      "Total revenue expected from a customer during their relationship with the brand",
      "Cost to acquire a customer",
      "Total marketing budget for a year",
    ],
    answer:
      "Total revenue expected from a customer during their relationship with the brand",
  },
  {
    id: 117,
    category: "Marketing",
    level: "hard",
    question: "What is 'PPC' in digital marketing?",
    options: [
      "Product Price Calculation",
      "Pay Per Click advertising",
      "Performance Planning Chart",
      "Post Purchase Communication",
    ],
    answer: "Pay Per Click advertising",
  },
  {
    id: 118,
    category: "Marketing",
    level: "hard",
    question: "What is the main goal of email marketing?",
    options: [
      "Educate employees",
      "Communicate directly with customers to build loyalty or drive sales",
      "Manage logistics",
      "Design packaging",
    ],
    answer:
      "Communicate directly with customers to build loyalty or drive sales",
  },
  {
    id: 119,
    category: "Marketing",
    level: "hard",
    question: "What is 'customer segmentation'?",
    options: [
      "Dividing customers based on common traits or behavior",
      "Setting pricing for products",
      "Managing employee teams",
      "Creating brand logos",
    ],
    answer: "Dividing customers based on common traits or behavior",
  },
  {
    id: 120,
    category: "Marketing",
    level: "hard",
    question: "What is a 'landing page'?",
    options: [
      "A homepage",
      "A page designed for a specific campaign or offer to convert visitors",
      "A blog post",
      "A social media profile",
    ],
    answer:
      "A page designed for a specific campaign or offer to convert visitors",
  },
  {
    id: 121,
    category: "Marketing",
    level: "hard",
    question:
      "Which metric shows how many visitors completed a desired action?",
    options: [
      "Bounce Rate",
      "Conversion Rate",
      "Engagement Rate",
      "Impressions",
    ],
    answer: "Conversion Rate",
  },
  {
    id: 122,
    category: "Marketing",
    level: "hard",
    question: "What is 'affiliate marketing'?",
    options: [
      "Promoting products via third parties for a commission",
      "Selling products in a store",
      "Managing internal staff",
      "Designing company logos",
    ],
    answer: "Promoting products via third parties for a commission",
  },
  {
    id: 123,
    category: "Marketing",
    level: "hard",
    question: "Which platform is mostly used for B2B marketing?",
    options: ["Instagram", "LinkedIn", "Snapchat", "TikTok"],
    answer: "LinkedIn",
  },
  {
    id: 124,
    category: "Marketing",
    level: "hard",
    question: "What is a 'call-to-action' (CTA)?",
    options: [
      "A marketing slogan",
      "An instruction to prompt an immediate response from the audience",
      "A website design element",
      "A logo style",
    ],
    answer: "An instruction to prompt an immediate response from the audience",
  },
  {
    id: 125,
    category: "Marketing",
    level: "hard",
    question: "Which is the main goal of social media marketing?",
    options: [
      "Increase brand awareness and engagement",
      "Hire new employees",
      "Manage finances",
      "Design packaging",
    ],
    answer: "Increase brand awareness and engagement",
  },
  {
    id: 126,
    category: "Marketing",
    level: "hard",
    question: "What does 'B2C marketing' mean?",
    options: [
      "Business to Customer",
      "Business to Company",
      "Brand to Company",
      "Buyer to Consumer",
    ],
    answer: "Business to Customer",
  },
  {
    id: 127,
    category: "Marketing",
    level: "hard",
    question: "Which is an example of experiential marketing?",
    options: [
      "Pop-up stores where customers try products",
      "Email newsletters",
      "SEO blog content",
      "TV advertisement",
    ],
    answer: "Pop-up stores where customers try products",
  },
  {
    id: 128,
    category: "Marketing",
    level: "hard",
    question: "What is 'remarketing'?",
    options: [
      "Targeting previous website visitors with ads",
      "Launching new products",
      "Managing finances",
      "Hiring marketing staff",
    ],
    answer: "Targeting previous website visitors with ads",
  },
  {
    id: 129,
    category: "Marketing",
    level: "hard",
    question: "Which content format is best for explaining complex topics?",
    options: [
      "Videos and infographics",
      "Short tweets",
      "Banner ads",
      "Flyers",
    ],
    answer: "Videos and infographics",
  },
  {
    id: 130,
    category: "Marketing",
    level: "hard",
    question: "Which is the main purpose of influencer marketing?",
    options: [
      "Promote brand via trusted individuals",
      "Design website logos",
      "Manage employee performance",
      "Optimize supply chain",
    ],
    answer: "Promote brand via trusted individuals",
  },

  // Data Analytics Questions (131-150)
  {
    id: 131,
    category: "Data Analytics",
    level: "hard",
    question: "In data analytics, what is data normalization?",
    options: [
      "Removing duplicates",
      "Scaling data to a common range for comparison",
      "Creating charts",
      "Encrypting data",
    ],
    answer: "Scaling data to a common range for comparison",
  },
  {
    id: 132,
    category: "Data Analytics",
    level: "hard",
    question: "Which chart is best for parts-to-whole relationships?",
    options: ["Line chart", "Pie chart", "Scatter plot", "Histogram"],
    answer: "Pie chart",
  },
  {
    id: 133,
    category: "Data Analytics",
    level: "hard",
    question: "Difference between supervised and unsupervised learning?",
    options: [
      "Supervised uses labeled data, unsupervised does not",
      "Supervised is faster",
      "Unsupervised needs supervision",
      "No difference",
    ],
    answer: "Supervised uses labeled data, unsupervised does not",
  },
  {
    id: 134,
    category: "Data Analytics",
    level: "hard",
    question: "What does R-squared indicate in regression?",
    options: [
      "Average dependent variable",
      "Variance explained by independent variables",
      "Slope of regression line",
      "Number of observations",
    ],
    answer: "Variance explained by independent variables",
  },
  {
    id: 135,
    category: "Data Analytics",
    level: "hard",
    question: "Which method detects outliers?",
    options: [
      "Z-score or standard deviation",
      "Mean only",
      "Sorting alphabetically",
      "Calculating mode",
    ],
    answer: "Z-score or standard deviation",
  },
  {
    id: 136,
    category: "Data Analytics",
    level: "hard",
    question: "What is a KPI in analytics?",
    options: [
      "Key Performance Indicator",
      "Known Process Information",
      "Key Product Idea",
      "Knowledge Planning Index",
    ],
    answer: "Key Performance Indicator",
  },
  {
    id: 137,
    category: "Data Analytics",
    level: "hard",
    question: "What is correlation?",
    options: [
      "Relationship between two variables",
      "A type of regression",
      "Data normalization",
      "A marketing metric",
    ],
    answer: "Relationship between two variables",
  },
  {
    id: 138,
    category: "Data Analytics",
    level: "hard",
    question: "Which visualization is best for trends over time?",
    options: ["Line chart", "Pie chart", "Histogram", "Scatter plot"],
    answer: "Line chart",
  },
  {
    id: 139,
    category: "Data Analytics",
    level: "hard",
    question: "What is the main purpose of dashboards?",
    options: [
      "To provide quick insights from data",
      "To store raw data",
      "To encrypt information",
      "To manage staff",
    ],
    answer: "To provide quick insights from data",
  },
  {
    id: 140,
    category: "Data Analytics",
    level: "hard",
    question: "What is a histogram used for?",
    options: [
      "Frequency distribution",
      "Scatter relationships",
      "Pie chart parts",
      "Text analysis",
    ],
    answer: "Frequency distribution",
  },
  {
    id: 141,
    category: "Data Analytics",
    level: "hard",
    question: "What is a pivot table?",
    options: [
      "A tool to summarize and analyze data",
      "A type of graph",
      "Data normalization method",
      "Email automation tool",
    ],
    answer: "A tool to summarize and analyze data",
  },
  {
    id: 142,
    category: "Data Analytics",
    level: "hard",
    question: "What is regression analysis used for?",
    options: [
      "Predicting a variable based on another",
      "Creating pie charts",
      "Managing marketing campaigns",
      "Measuring brand equity",
    ],
    answer: "Predicting a variable based on another",
  },
  {
    id: 143,
    category: "Data Analytics",
    level: "hard",
    question: "What is a dataset?",
    options: [
      "Collection of data",
      "Type of chart",
      "Marketing metric",
      "A KPI",
    ],
    answer: "Collection of data",
  },
  {
    id: 144,
    category: "Data Analytics",
    level: "hard",
    question: "What is the mean of a dataset?",
    options: ["Average value", "Maximum value", "Minimum value", "Median"],
    answer: "Average value",
  },
  {
    id: 145,
    category: "Data Analytics",
    level: "hard",
    question: "What is the median?",
    options: ["Middle value", "Average value", "Mode", "Range"],
    answer: "Middle value",
  },
  {
    id: 146,
    category: "Data Analytics",
    level: "hard",
    question: "What is the mode in data?",
    options: ["Most frequent value", "Middle value", "Average", "Maximum"],
    answer: "Most frequent value",
  },
  {
    id: 147,
    category: "Data Analytics",
    level: "hard",
    question: "What is standard deviation?",
    options: [
      "A measure of spread of data",
      "Sum of all values",
      "Average",
      "Minimum",
    ],
    answer: "A measure of spread of data",
  },
  {
    id: 148,
    category: "Data Analytics",
    level: "hard",
    question: "What is variance?",
    options: [
      "Average of squared differences from mean",
      "Maximum value",
      "Difference between max and min",
      "Mode",
    ],
    answer: "Average of squared differences from mean",
  },
  {
    id: 149,
    category: "Data Analytics",
    level: "hard",
    question: "Which chart shows distribution of two variables?",
    options: ["Scatter plot", "Pie chart", "Histogram", "Line chart"],
    answer: "Scatter plot",
  },
  {
    id: 150,
    category: "Data Analytics",
    level: "hard",
    question: "What is data cleaning?",
    options: [
      "Removing errors and inconsistencies",
      "Creating graphs",
      "Marketing strategy",
      "Segmentation",
    ],
    answer: "Removing errors and inconsistencies",
  },
];

export default marketingData;
